<template lang="html">
  <div class="layout-page" :style="stylechat">
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
      <v-col
        cols="1"
        justify="center"
        align="center"
        class="pa-0"
        @click="routePage()"
      >
        <v-icon class="fz-30">mdi-chevron-left</v-icon>
      </v-col>
      <v-col
        cols="10"
        justify="center"
        align="center"
        class="pa-0"
      >
        <span class="tab-title">{{$t('Settings.editProfile.group')}}</span>
      </v-col>
      <v-col cols="1"></v-col>
    </v-layout>
    <v-divider class="mt-4 mb-2"></v-divider>
    <v-layout row wrap justify-center align-start class="pt-5 pl-5 pr-5 pb-2">
      <v-avatar
        size="100"
      >
      <img v-if="data_group.picture" :src="data_group.picture" alt="" class="img-position">
      <img v-else :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position">
      </v-avatar>
    </v-layout>
    <v-layout column class="mt-4" justify-center align-center style="text-align: center;">
      <span class="text-title text-overflow">{{data_group.name}}</span>
    </v-layout>
    <v-layout row wrap justify-start align-start class="pt-6 pl-5 pr-5 pb-5 mt-2">
      <v-flex xs6 sm6 md6 class="pr-2">
        <v-btn block class="btn-confirm text-transform" rounded @click="checkState(relation)" :loading="loading">
          <v-icon class="mr-2">{{icon_btn}}</v-icon>
          {{text_btn}}
        </v-btn>
      </v-flex>
      <v-flex xs6 sm6 md6 class="pl-2">
        <v-btn v-if="relation === 'pending'" block class="btn-cancel text-transform" outlined rounded @click="openDialog('cancelgroup')" :loading="loading_cancel">
          {{$t('AnswerQuestion.cancelInvite')}}
        </v-btn>
        <v-btn v-if="relation === 'active' || relation === 'group'" block class="btn-cancel text-transform" outlined rounded @click="openDialog('invitefriend')" :loading="loading">
          {{$t('RightSide.menu.invite')}}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-divider class="ma-3"></v-divider>
    <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-2 mt-2">
      <b>{{$t('Settings.editProfile.group')}}</b>
    </v-layout>
    <!-- statemember active -->
    <div v-if="relation === 'active'">
      <v-layout  row wrap justify-start align-center class="pl-5 pr-5 pb-3 mt-5" @click="openDialog('membergroup')">
        <v-icon class="mr-3 icon-color">mdi-account-multiple</v-icon>
        <span class="tab-title-status" v-if="data_group.count_member">{{$t('RightSide.member')}} ({{data_group.count_member}})</span>
        <v-spacer></v-spacer>
        <v-item-group class="pr-4">
          <v-item
            v-for="(item, index) in member_active"
            :key="index"
          >
            <v-avatar size="30" v-if="index <= 2">
              <img v-if="item.profile" :src="item.profile" alt="" class="img-position">
              <img v-else-if="item.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
              <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
              <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
              <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
            </v-avatar>
            <v-avatar
              class="btn-confirm"
              size="30"
              v-else-if="index === 3"
            >
              <span class="white--text" v-if="parseInt(member_active.length - 3) <= 99">+{{parseInt(member_active.length - 3)}}</span>
              <span class="white--text" v-else>+99</span>
            </v-avatar>
          </v-item>
        </v-item-group>
        <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
      </v-layout>
      <!-- <v-layout  row wrap justify-start align-center class="pl-5 pr-5 pb-3 mt-5" @click="openDialog('notegroup')">
        <v-icon class="mr-3 icon-color">fas fa-sticky-note</v-icon>
        <span class="tab-title-status">{{$t('RightSide.menu.note')}}</span>
        <v-spacer></v-spacer>
        <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
      </v-layout> -->
      <v-divider class="mt-5 ml-3 mr-3 mb-5"></v-divider>
      <v-layout  row wrap justify-start align-center class="pl-5 pr-5 pb-3 mt-5" @click="openDialog('settinggroup')">
        <v-icon class="mr-3 icon-color">fa-solid fa-gear</v-icon>
        <span class="tab-title-status">{{$t('RightSide.menu.setting')}}</span>
        <v-spacer></v-spacer>
        <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
      </v-layout>
      <v-layout  row wrap justify-start align-center class="pl-5 pr-5 pb-3 mt-5" @click="openDialog('leavegroup')">
        <v-icon class="mr-3 icon-color">fa-solid fa-right-from-bracket</v-icon>
        <span class="tab-title-status">{{$t('RightSide.menu.leave')}}</span>
        <v-spacer></v-spacer>
        <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
      </v-layout>
    </div>
    <!-- statemember pending -->
    <div v-if="relation === 'pending'">
      <v-layout row wrap justify-start align-center class="pl-5 pr-5 pb-2 mt-5" @click="openDialog('membergroup')">
        <v-icon class="mr-3 icon-color">mdi-account-multiple</v-icon>
        <span class="tab-title-status" v-if="data_group.count_member">{{$t('RightSide.member')}} ({{data_group.count_member}})</span>
        <v-spacer></v-spacer>
        <v-item-group class="pr-4">
          <v-item
            v-for="(item, index) in member_active"
            :key="index"
          >
            <v-avatar size="30" v-if="index <= 2">
              <img v-if="item.profile" :src="item.profile" alt="" class="img-position">
              <img v-else-if="item.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
              <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
              <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
              <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
            </v-avatar>
            <v-avatar
              class="btn-confirm"
              size="30"
              v-else-if="index === 3"
            >
              <span class="white--text" v-if="parseInt(member_active.length - 3) <= 99">+{{parseInt(member_active.length - 3)}}</span>
              <span class="white--text" v-else>+99</span>
            </v-avatar>
          </v-item>
        </v-item-group>
        <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
      </v-layout>
    </div>
    <SettingGroup :SettingGroupDialog="SettingGroupDialog" :SettingGroupDetail="SettingGroupDetail" @closeComponents="closeComponents"/>
    <InviteMemberGroup :InviteMemberDialog="InviteMemberDialog" :InviteMemberDetail="InviteMemberDetail" @closeComponents="closeComponents"/>
    <MemberGroup :MemberGroup="MemberGroup" :MemberGroupDetail="MemberGroupDetail" @closeComponents="closeComponents"/>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import ErrorDialog from '@/components/Alert/Error'
import Warning from '@/components/Alert/Warning'
import MemberGroup from '@/components/MemberGroup'
import InviteMemberGroup from '@/components/InviteMemberGroup'
import SettingGroup from '@/components/SettingGroup'
var _ = require('lodash')
export default {
  data () {
    return {
      loading_cancel: false,
      publicPath: process.env.VUE_APP_BASE_PATH,
      SettingGroupDialog: false,
      SettingGroupDetail: {},
      InviteMemberDialog: false,
      InviteMemberDetail: {},
      MemberGroup: false,
      MemberGroupDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      icon_btn: '',
      loading: false,
      ErrorDialogDetail: {},
      ErrorDialog: false,
      relation: '',
      text_btn: '',
      progress: false,
      data_user: {},
      data_group: {},
      stylechat: {
        "--ProfileGroup-HeaderColor": "white",
        "--ProfileGroup-TabBackground": "white",
        "--ProfileGroup-Icon": "gray",
        "--ProfileGroup-IconActive": "#2662ae",
        "--ProfileGroup-Background": "white",
        "--ProfileGroup-FontSize": "18px",
        "--ProfileGroup-FontSize-Title": "24px",
        "--ProfileGroup-FontColor": "back",
        "--ProfileGroup-FontSize-Status": "16px",
        "--ProfileGroup-FontColor-Status": "grey",
        "--ProfileGroup-Background-Input": "#E2E1E3",
        "--ProfileGroup-Color-Button": "#EFF2FE",
        "--ProfileGroup-FontColor-Button": "#2662ae",
        "--ProfileGroup-FontColor-Block-Button": "#cb1002",
        "--ProfileGroup-FontColor-Dis-Button": "#e2e1e3",
        "--ProfileGroup-Btn-Confirm-Background": "#2662ae",
        "--ProfileGroup-Btn-Confirm-Color": "white",
        "--ProfileGroup-Btn-Confirm-FontSize": "18px",
        "--ProfileGroup-Btn-Cancel-Background": "white",
        "--ProfileGroup-Btn-Cancel-Color": "#2662ae",
        "--ProfileGroup-Btn-Cancel-FontSize": "18px",
        "--ProfileGroup-Btn-Leave-Background": "white",
        "--ProfileGroup-Btn-Leave-Color": "#ff5252",
        "--ProfileGroup-Btn-Leave-FontSize": "18px"
      },
      member_active: [],
    }
  },
  computed: {
    ...sync('*')
  },
  components: {
    ErrorDialog,
    Warning,
    MemberGroup,
    InviteMemberGroup,
    SettingGroup
  },
  created () {
    // console.log('themechat group', this.themechat)
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    this.getGroup(this.$route.params.groupid)
  },
  methods: {
    emitWarning (data) {
      this.WarningDialog = false
      if (data.detail === 'leavegroup') {
        this.leaveGroup()
      } else if (data.detail === 'cancelgroup') {
        this.cancelGroup()
      }
    },
    openDialog (text) {
      // console.log(text)
      if (text === 'leavegroup') {
        this.WarningDialogDetail = {
          title: this.data_group.name,
          text: this.$t('Alert.Right.leaveGroup'),
          detail: 'leavegroup',
          index: 0
        }
        this.WarningDialog = true
      } else if (text === 'cancelgroup') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Group.cancelGroup', { name: this.data_group.name }),
          detail: 'cancelgroup',
          index: 0
        }
        this.WarningDialog = true
      } else if (text === 'invitefriend') {
        // console.log('invite friend')
        this.InviteMemberDetail = this.data_group
        this.InviteMemberDialog = true
      } else if (text === 'membergroup') {
        this.MemberGroupDetail = this.data_group
        this.MemberGroup = true
      } else if (text === 'settinggroup') {
        this.SettingGroupDetail = this.data_group
        this.SettingGroupDialog = true
      }
    },
    closeComponents (item) {
      if (item.name === 'membergroup') {
        this.MemberGroup = item.value
        this.getGroup(this.$route.params.groupid)
      } else if (item.name === 'invitemember') {
        this.InviteMemberDialog = item.value
        this.getGroup(this.$route.params.groupid)
      } else if (item.name === 'settinggroup') {
        this.SettingGroupDialog = item.value
        this.getGroup(this.$route.params.groupid)
      }
    },
    closeAlertDialog (item) {
      if (item.type === 'err') {
        this.ErrorDialog = false
      } else if (item.type === 'warning') {
        this.WarningDialog = false
      }
    },
    routePage () {
      // this.$router.push(path)
      this.$router.go(-1)
    },
    getGroup (id) {
      // console.log(tokenfriend)
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/getgroup`, {
        tokenuser: this.data_user.tokenuser,
        group_id: id
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.data_group = response.data['group']
          this.member_active = _.filter(this.data_group.member, function (o) { return o.statemember === 'active' })
          this.relation = response.data['group']['state']
          if (this.relation === 'pending') {
            this.text_btn = this.$t('AnswerQuestion.joinGroup')
            this.icon_btn = 'mdi-account-plus'
          } else if (this.relation === 'active' || this.relation === 'group') {
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon_btn = 'fa-solid fa-comment-dots'
          }
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
      })
    },
    leaveGroup () {
      this.loading = true
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/leave-group`, {
        tokenuser: this.data_user.tokenuser,
        group_id: this.data_group.group_id,
        listmember: [this.data_user.tokenuser]
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.loading = false
          this.progress = false
          this.$router.push('/homepage')
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    cancelGroup () {
      this.loading_cancel = true
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/cancelinvitegroup`, {
        tokenuser: this.data_user.tokenuser,
        group_id: this.data_group.group_id,
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.loading_cancel = false
          this.progress = false
          this.$router.push('/homepage')
        } else {
          this.loading_cancel = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.loading_cancel = false
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    checkState (relation) {
      if (relation === 'active' || relation === 'group') {
        this.$router.push(`/chat/${this.data_group.tokenroom}`)
      } else if (relation === 'pending') {
        // เข้ากลุ่ม
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/accept-group`, {
          group_id: this.data_group.group_id,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.relation = 'active'
          } else {
            this.loading = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>
.icon-color-edit {
  color: var(--ProfileGroup-Icon) !important;
}
.icon-color {
  color: var(--ProfileGroup-IconActive) !important;
}
.btn-confirm {
  background-color: var(--ProfileGroup-Btn-Confirm-Background) !important;
  color: var(--ProfileGroup-Btn-Confirm-Color) !important;
  font-size: var(--ProfileGroup-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--ProfileGroup-Btn-Cancel-Background) !important;
  color: var(--ProfileGroup-Btn-Cancel-Color) !important;
  font-size: var(--ProfileGroup-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--ProfileGroup-Btn-Leave-Background) !important;
  color: var(--ProfileGroup-Btn-Leave-Color) !important;
  font-size: var(--ProfileGroup-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--ProfileGroup-Background) !important;
}
.fz-30 {
  font-size: 30px;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--ProfileGroup-FontSize-Title) !important;
  color: var(--ProfileGroup-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--ProfileGroup-FontColor) !important;
  font-size: var(--ProfileGroup-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--ProfileGroup-FontColor-Status) !important;
  font-size: var(--ProfileGroup-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
